<template>
    <v-col v-bind="DASHBOARD_WIDGET_COLUMNS.LARGE">
        <v-card>
            <v-toolbar color="grey-lighten-4" density="compact" flat>
                <template #title>{{ widget.body?.title }}</template>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-data-table :headers="headers" :items="userTaskItems" density="compact" item-value="id">
                    <template #item.plannedFinishDate="{ item }">{{ formatDateForDisplay(item.plannedFinishDate) }}</template>
                    <template #item.actions>
                        <div class="d-flex justify-center">
                            <v-btn disabled icon="mdi-check" size="small" variant="text" />
                            <v-btn disabled icon="mdi-ballot" size="small" variant="text" />
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'

import { useDashboardStore } from '@/stores'
import type { DashboardPermission, DashboardWidget } from '@/stores/dashboard'
import type { DataTableHeader } from '@/types/dataTable'
import { DASHBOARD_WIDGET_COLUMNS, formatDateForDisplay } from '@/views/Dashboard/dashboardUtils'

type UserTaskRow = { title?: string; plannedFinishDate?: string }

// 2. Props / Emits
withDefaults(
    defineProps<{
        widget: DashboardWidget
        permissions?: DashboardPermission[]
    }>(),
    { permissions: () => [] }
)

// 3. Constants
const headers: DataTableHeader[] = [
    { title: 'Temat', key: 'title', sortable: false },
    { title: 'Data ukończenia', key: 'plannedFinishDate', sortable: false, width: 150 },
    { title: 'Akcje', key: 'actions', sortable: false, align: 'center', width: 100 }
]

// 4. Stores & top-level services
const dashboardStore = useDashboardStore()

// 7. Computed
const userTaskItems = computed(() => dashboardStore.userTasks as UserTaskRow[])
</script>
